import { render, staticRenderFns } from "./SubscriptionPlate.vue?vue&type=template&id=4cf9e446&"
import script from "./SubscriptionPlate.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports